import React from 'react';
import { useDarkMode } from '../../../context/DarkModeContext';

const ResultsTabSkeleton: React.FC = () => {
  const { darkMode } = useDarkMode();
  
  const bgColor = darkMode ? 'bg-gray-800' : 'bg-gray-100';
  const shimmer = darkMode ? 'bg-gray-700' : 'bg-gray-200';
  
  return (
    <div className="space-y-6">
      {/* Outcome Summary Skeleton */}
      <div className={`${bgColor} rounded-lg p-6`}>
        <div className={`${shimmer} h-6 w-40 mb-4 rounded animate-pulse`} />
        <div className={`${shimmer} h-4 w-60 mb-2 rounded animate-pulse`} />
        <div className={`${shimmer} h-4 w-48 rounded animate-pulse`} />
      </div>
      
      {/* Goal Achievement Skeleton */}
      <div className={`${bgColor} rounded-lg p-6`}>
        <div className={`${shimmer} h-6 w-48 mb-4 rounded animate-pulse`} />
        <div className="space-y-3">
          <div className={`${shimmer} h-12 rounded animate-pulse`} />
          <div className={`${shimmer} h-12 rounded animate-pulse`} />
          <div className={`${shimmer} h-12 rounded animate-pulse`} />
        </div>
      </div>
      
      {/* Documents Skeleton */}
      <div className={`${bgColor} rounded-lg p-6`}>
        <div className={`${shimmer} h-6 w-32 mb-4 rounded animate-pulse`} />
        <div className="space-y-2">
          <div className={`${shimmer} h-10 rounded animate-pulse`} />
          <div className={`${shimmer} h-10 rounded animate-pulse`} />
        </div>
      </div>
    </div>
  );
};

export default ResultsTabSkeleton;